/**
 * Central brand configuration for VerseSport™.
 * White-label tenants can override these values at runtime.
 */
export interface BrandConfig {
  productName: string;
  productShortName: string;
  tagline: string;
  legalOwner: string;
  copyrightText: string;
  defaultMetaTitle: string;
  defaultMetaDescription: string;
  legalFooterText: string;
}

export const DEFAULT_BRAND: BrandConfig = {
  productName: "VerseSport™",
  productShortName: "VerseSport",
  tagline: "Inteligencia Deportiva en Tiempo Real",
  legalOwner: "Inneli Technology Corp. PBC",
  copyrightText: `© ${new Date().getFullYear()} Inneli Technology Corp. PBC. All rights reserved.`,
  defaultMetaTitle: "VerseSport — Inteligencia Deportiva en Tiempo Real",
  defaultMetaDescription:
    "Plataforma global de segunda pantalla con telemetría, IA, predicciones, recompensas y analítica comercial en tiempo real.",
  legalFooterText:
    "VerseSport™ is a proprietary second-screen infrastructure developed and operated exclusively by Inneli Technology Corp. PBC. All rights reserved under Delaware Corporate Law.",
};

export interface TenantBrandOverride {
  customBrandName?: string;
  customTagline?: string;
  customLogo?: string;
}

export function resolveBrand(override?: TenantBrandOverride | null): BrandConfig {
  if (!override) return DEFAULT_BRAND;
  return {
    ...DEFAULT_BRAND,
    productName: override.customBrandName ?? DEFAULT_BRAND.productName,
    productShortName: override.customBrandName ?? DEFAULT_BRAND.productShortName,
    tagline: override.customTagline ?? DEFAULT_BRAND.tagline,
  };
}

const OVERRIDE_KEY = "vs:brand_override";

export function getBrandOverride(): TenantBrandOverride | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(OVERRIDE_KEY);
    return raw ? (JSON.parse(raw) as TenantBrandOverride) : null;
  } catch {
    return null;
  }
}

export function setBrandOverride(override: TenantBrandOverride | null) {
  if (typeof window === "undefined") return;
  if (!override) window.localStorage.removeItem(OVERRIDE_KEY);
  else window.localStorage.setItem(OVERRIDE_KEY, JSON.stringify(override));
}

export function getBrand(): BrandConfig {
  return resolveBrand(getBrandOverride());
}